export const initials = (name) => (name || "?").trim().split(/\s+/).map((w) => w[0]).slice(0, 2).join("").toUpperCase();

export const assigneeKey = (a) => `${a.type}:${a.id}`;

// Resolves task.assignees refs against board.members / board.teams
export const resolveAssignees = (task, board) => {
  const members = board?.members || [];
  const teams = board?.teams || [];
  return (task.assignees || []).map((a) => {
    if (a.type === "team") {
      const t = teams.find((x) => x.id === a.id);
      return t ? { ...a, name: t.name, color: t.color, key: assigneeKey(a) } : null;
    }
    const u = members.find((x) => x.id === a.id);
    return u ? { ...a, name: u.name, role: u.role, key: assigneeKey(a) } : null;
  }).filter(Boolean);
};
